import i18n from '../../locales/index'
/* eslint-disable */
import { genBasicStore } from '../vuex';
import axios from 'axios'
const module = genBasicStore('mall_product');

module.actions['publish'] = async ({ dispatch }, id) => {
    await axios.post(`/mall_products/${id}/publish`);
    dispatch('index', { page: 1, per: 65535 });
}

export default module;